import { useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { useAuth } from "../hooks/useAuth";
import { notificationService } from "../services/notificationService";

const TYPE_LABELS = {
  access_approved: "Access approved",
  access_rejected: "Access update",
  certificate_issued: "Certificate ready",
  course_assigned: "Course assigned",
  course_completed: "Course completed",
  course_enrolled: "Enrollment confirmed",
  partner_approved: "Partner approved",
  waitlist_promoted: "Seat available",
};

const getToastTitle = (notification) =>
  notification.title || TYPE_LABELS[notification.type] || "Notification";

const showNotificationToast = (notification) => {
  const title = getToastTitle(notification);
  const message = notification.message || "";

  toast(
    <div className="space-y-1">
      <p className="text-[13px] font-semibold leading-snug">{title}</p>
      {message && (
        <p className="text-[12px] leading-snug text-zinc-300">{message}</p>
      )}
    </div>,
    { duration: 6000 },
  );
};

const GlobalNotificationToasts = () => {
  const { user } = useAuth();
  const shownIdsRef = useRef(new Set());

  useEffect(() => {
    if (!user?.id) return undefined;

    const channel = notificationService.subscribeToNotifications(
      user.id,
      (notification) => {
        if (!notification?.id || shownIdsRef.current.has(notification.id)) {
          return;
        }

        shownIdsRef.current.add(notification.id);
        showNotificationToast(notification);
        void notificationService.markAsRead(notification.id);
      },
    );

    return () => {
      notificationService.unsubscribe(channel);
    };
  }, [user?.id]);

  return null;
};

export default GlobalNotificationToasts;
